// Helper function to find a country by its common name
const findCountry = (fullName, countriesData) => {
  // Check if the country exists in countriesData
  const result = countriesData.find((c) => c.name === fullName);

  if (!result) {
    console.warn("No country found with that name.");
    return null;
  }
  return result || null;
};

// The main transformation function
export const getCombinedProducts = (productsData, countriesData) => {
  return productsData.map((product) => {
    // 1. Parse the product name
    const parts = product.productName.split("/");
    const countryName = parts[0];
    const country = findCountry(countryName, countriesData);

    // 2. Determine product type and details
    let productType = "Package"; // default
    let details = [];

    if (product.typeName.includes("eSIM")) {
      productType = "eSim";
      const dataMatch = product.typeName.match(/(\d+GB)/);
      if (dataMatch) details.push(`Data ${dataMatch[1]}`);
    } else if (product.typeName.includes("Voice")) {
      productType = "Voice";
      const validityMatch = product.typeName.match(/(\d+Days)/);
      if (validityMatch) details.push(`Validity ${validityMatch[1]} Days`);
    } else if (
      product.typeName.includes("Package") ||
      product.typeName.includes("Data")
    ) {
      productType = "Package";
      //const dataMatch = product.typeName.match(/(\d+GB)/);
      const dataMatch = parts;
      if (dataMatch) {
        details.push(`Data ${dataMatch[0]}`);
        details.push(`Validity ${dataMatch[1]}`);
      }
      if (countryName === "Global") details.push("Global Coverage");
    }

    // 3. Return the new, combined object
    return {
      id: product.id,
      countryCode: country ? country.code : "un", // Fallback to UN flag if not found
      countryName: country ? country.name : countryName,
      productType: productType,
      price: product.price,
      details: details,
    };
  });
};

// This function joins the two arrays based on the ID
// getProductsWithCountryData: now uses regions (not countries) to resolve flag/isoCode
export const getProductsWithCountryData = (productsData, regionsData) => {
  return productsData
    .map((product) => {
      // Match product to its region directly by regionId
      const region = regionsData.find((r) => r.id === product.regionId);

      let productType = product.typeName;
      let details = [];

      if (product.typeName && product.typeName.includes("eSIM")) {
        productType = "eSIM";
        details.push(product.productName);
      } else if (product.typeName && product.typeName.includes("Recharge")) {
        productType = "Recharge";
        details.push(product.productName);
      }

      return {
        id: product.id,
        // isoCode from linked country; null means no country → ServicePlanCard uses flag.png
        isoCode:
          region && region.isoCode && region.isoCode.trim().length === 2
            ? region.isoCode.toLowerCase()
            : null,
        regionName: product.regionName || (region ? region.name : "N/A"),
        productType: productType,
        isRenew: product.isRenew ? true : false,
        price: product.price,
        details: details,
        product: product,
      };
    })
    .filter(Boolean);
};
